import axiosClient from "api/axios_client.js";

const BASE = "/reminder-builder/reminder-setup/domain-event";

// tbl_rem_domain_event. Write calls are Super Admin only. The source dropdown comes from ../api.js.
const apiReminderDomainEvent = {
  create:  (payload)     => axiosClient.post(`${BASE}/create`, payload),
  update:  (id, payload) => axiosClient.put(`${BASE}/update/${id}`, payload),
  getAll:  (payload)     => axiosClient.post(`${BASE}/get-all`, payload),
  getById: (id)          => axiosClient.get(`${BASE}/get-by-id/${id}`),
  delete:  (ids)         => axiosClient.delete(`${BASE}/delete`, { data: { ids } }),
};

export default apiReminderDomainEvent;
